"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DOSSIER_STATE = void 0;
var DOSSIER_STATE = {
  VALID: 'VALID',
  WARNING: 'WARNING',
  INVALID: 'INVALID',
  EMPTY: 'EMPTY',
  DEPOSITOR_SERVICE_DEACTIVATED: 'DEPOSITOR_SERVICE_DEACTIVATED',
  AWAITING_VERIFICATION: 'AWAITING_VERIFICATION'
};
exports.DOSSIER_STATE = DOSSIER_STATE;
var dossiersUtils = {
  DOSSIER_STATE: DOSSIER_STATE
};
var _default = dossiersUtils;
exports.default = _default;
//# sourceMappingURL=dossiers.js.map